/**
 * contractDetailOutrightApi — RTK Query slice cho Contract Detail
 * "Add Pay Outright" batch dialog (artifact C2).
 *
 * BE: /purchase/contract-detail/outright/preview + /outright/save
 * (backend/app/api/v1/endpoints/purchase/contract_detail_outright.py).
 * Types snake_case khớp model BE (không camelCase alias).
 */
import { baseApi } from './baseApi'

export interface OutrightRowInput {
  payment_type?: string | null
  truck_id?: string | null
  bank_name?: string | null
  quantity_kg?: number | null
  advanced_vnd?: number | null
  advanced_sub_vnd?: number | null
  /** Percent 0–100 (BE quy về fraction Access). */
  pct_pay?: number | null
  description?: string | null
  vat_amount_vnd?: number | null
}

export interface OutrightPreviewRequest {
  contract_no: string
  /** Parse từ ô "Requested FX" màn cha; null → BE fallback fixed_fx. */
  requested_fx?: number | null
  rows: OutrightRowInput[]
}

export interface OutrightSaveRequest extends OutrightPreviewRequest {
  /** 1 giá trị XNTT No chung cho mọi dòng. */
  xntt_no?: string | null
}

export interface OutrightPreviewRow {
  date: string
  contract_no: string
  payment_type: string | null
  truck_id: string | null
  price: number | null
  price_unit: string | null
  requested_fx: number | null
  bank_name: string | null
  quantity_kg: number | null
  to_be_requested: number | null
  advanced_vnd: number | null
  request_vnd: number | null
  vat_amount_vnd: number | null
  advanced_sub_vnd: number | null
  request_sub_vnd: number | null
  description: string | null
}

export interface OutrightPreviewResponse {
  rows: OutrightPreviewRow[]
  /** "To be Receive" — mv_local_p.pending. */
  pending: number | null
  fixed_fx: number | null
  vat_txt: string | null
  /** "Pending.Outright" — SUM(to_be_requested). */
  pending_outright: number | null
  /** Requested FX resolved (payload ?? fixed_fx). */
  requested_fx: number | null
  /** "New Pending.Outright" = pending_outright − SUM(Quantity (KG)). */
  new_pending: number | null
  contract_type: string | null
  price_unit: string | null
}

export interface OutrightSaveResponse {
  raw_records: number
  errors: number
}

export const contractDetailOutrightApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    outrightPreview: b.mutation<OutrightPreviewResponse, OutrightPreviewRequest>({
      query: (body) => ({
        url: '/purchase/contract-detail/outright/preview',
        method: 'POST',
        body,
      }),
    }),
    outrightSave: b.mutation<OutrightSaveResponse, OutrightSaveRequest>({
      query: (body) => ({
        url: '/purchase/contract-detail/outright/save',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'PayData', id: 'LIST' }],
    }),
  }),
})

export const { useOutrightPreviewMutation, useOutrightSaveMutation } = contractDetailOutrightApi
